import schema from '../schemas/_mortgageCalculator';

const mortgageCalculatorReducer = (state = schema, action) => {
  switch (action.type) {
    case 'SET_MORTGAGE_CALCULATOR':
      return {
        ...action.data,
      };

    default:
      return {
        ...state,
      };
  }
};

export { mortgageCalculatorReducer };
